import { useEffect, useMemo } from 'react';

import DebugTrigger, { DebugTriggerOptions } from '../util/DebugTrigger';

export default function useDebugTrigger(options: DebugTriggerOptions) {
  const debugTrigger = useMemo(() => new DebugTrigger(options), [options]);
  useEffect(() => {
    debugTrigger.init();
    return () => debugTrigger.close();
  }, [debugTrigger, options]);
}
